// Reading the account context UserDb keeps in localStorage, with no Angular in it, so it can be
// tested (`UserDb` itself cannot be constructed under the unit-test harness).
//
// Two keys live there: the coach-managing-a-client context and the admin impersonation auth.
// Both are read on almost every navigation, so UserDb hands the read a once-per-page-load
// reporter from util/once-per-condition-reporter (#5191).

import { ConditionReporter } from 'util/once-per-condition-reporter';

/** The one method of `localStorage` a read needs. */
export interface StoredJsonReader {
  getItem(key: string): string | null;
}

/**
 * The parsed value stored under `key`, or null when nothing is stored or it cannot be read.
 *
 * A read can fail two ways: the storage getter throws (site data blocked, or the browser refuses
 * storage), or the stored text is not valid JSON. Either way the caller gets null, which means
 * "no such context", and the failure goes to `report`.
 */
export function readStoredJson<T>(storage: StoredJsonReader, key: string, conditionName: string, report: ConditionReporter): T | null {
  try {
    const stored = storage.getItem(key);
    return stored ? JSON.parse(stored) as T : null;
  } catch (err) {
    report(conditionName, err);
    return null;
  }
}
